import { gql } from '@apollo/client';

export const BLOG_POSTS = gql`
  query GetBlogPosts {
    blog{
      id
      title
      image
      date,
      categoryByCategory {
        id
        category
      }
    }
  }
`;

export const GALLERY_IMAGES = gql`
  query GetGalleryImages {
    gallery( order_by: {id: desc}){
        id
        image
      }
  }
`;

export const GET_BLOG_DETAILS = gql`
  query GetBlogDetails(\$id: Int!) {
    blog_by_pk(id: \$id){
        title
        image
        date,
        blog
        categoryByCategory {
          id
          category
        }
      }
    
  }
`;


export const GET_BLOG_CATEGORY_POSTS = gql`
  query GetCategoryBlogPosts(\$category: String!) {
        blog(where: {categoryByCategory: {category: {_ilike: \$category}}}) {
          id
          title
          image
          date,
          categoryByCategory {
            id
            category
          }
      }
  }
`;

export const GET_CATEGORIES_NAV = gql`
    query getCategoryNav{
        category {
        category
        id
        blogs_aggregate {
            aggregate {
            count
            }
        }
        }
    
    }
`;

export const LATEST_BLOG_POSTS = gql`
  query GetBlogPosts {
    blog(limit: 4, order_by: {date: desc}) {
      id
      title
      image
      date,
      categoryByCategory {
        id
        category
      }
    }
  }
`;

export const BLOG_POST_COMMENTS = gql`
  query GetBlogPostComments(\$blogId: Int!) {
    comments(where: {blog: {_eq: \$blogId}}){
        comment
        id
        username
        email
      }
    comments_aggregate(where: {blog: {_eq: \$blogId}}) {
        aggregate {
          count
        }
      }
  }
`;


